import api from "api/api";

// mui component
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";

//Props Validations
import PropTypes from "prop-types";

// redux
import { useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

function ClaimsDataDeleteComponent({ title = "", component = "", selectedRows = [], isOpen = false, setIsDeleteDialogOpen = () => {}, fetchData = () => {} }) {
    const dispatch = useDispatch();

    const filteredData = selectedRows.filter((datum) => (component === "statements" ? datum.study_reference__title.length > 0 : datum.statement__title.length > 0));

    const handleDelete = () => {
        const selectedIds = selectedRows.map((datum) => datum.id);
        const payload = { ids: selectedIds };
        try {
            let url;
            if (component === "statements") {
                url = process.env.REACT_APP_SERVER_PATH + `/claims-mappings/multiple-delete/`;
            } else if (component === "tags") {
                url = process.env.REACT_APP_SERVER_PATH + `/claims-tags/multiple-delete/`;
            }
            api.put(url, payload)
                .then(() => {
                    fetchData();
                    handleClose();
                })
                .catch((error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
    };

    const handleClose = () => {
        setIsDeleteDialogOpen(false);
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={isOpen}
                fullWidth={true}
                // maxWidth={"sm"}
                sx={{
                    "& .MuiDialog-paper": {
                        maxWidth: "660px",
                        width: "100%",
                    },
                }}
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 15,
                        textAlign: "center",
                        padding: "10px 12px",
                    }}
                    // className="liner-light-blue-background-2"
                >
                    {`Are you sure you want to delete the following ${component === "statements" ? "Claims statements" : "tags"} :`}
                </DialogTitle>
                <DialogContent>
                    {filteredData.length !== 0 ? (
                        <div
                            style={{
                                maxHeight: 500,
                                padding: "20px",
                                textAlign: "center",
                            }}
                        >
                            <p
                                style={{
                                    fontWeight: "bold",
                                    fontSize: 15,
                                }}
                            >
                                {title}
                            </p>
                            {filteredData.map((datum, i) => {
                                const titleList = component === "statements" ? datum.study_reference__title : datum.statement__title;
                                return (
                                    <Grid
                                        container
                                        spacing={2}
                                        key={i}
                                    >
                                        <Grid
                                            item
                                            xs={6}
                                            style={{
                                                fontSize: 14,
                                                textAlign: "left",
                                                wordWrap: "break-word",
                                            }}
                                        >
                                            {/* <p>{component === "statements" ? datum.statement : datum.title}</p> */}
                                            <ul>
                                                <li
                                                    key={i}
                                                    style={{ fontSize: 14 }}
                                                >
                                                    {component === "statements" ? datum.statement : datum.title}
                                                </li>
                                            </ul>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={6}
                                        >
                                            <ul
                                                key={i}
                                                style={{ textAlign: "left" }}
                                            >
                                                {titleList.map((title, i) => {
                                                    return (
                                                        <li
                                                            key={i}
                                                            style={{ fontSize: 14 }}
                                                        >
                                                            {title}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </Grid>
                                    </Grid>
                                );
                            })}
                            {/* {component === "statements" && } */}
                            {selectedRows.filter((datum) => (component === "statements" ? datum.study_reference__title.length === 0 : datum.statement__title.length === 0)).length !== 0 && (
                                <p
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 15,
                                        marginTop: "10px",
                                    }}
                                >
                                    {component === "statements" ? "The following Claims statements are not present in any of the studies :" : "The following tags are not present in any of the claim statements :"}
                                </p>
                            )}
                            {selectedRows
                                .filter((datum) => (component === "statements" ? datum.study_reference__title.length === 0 : datum.statement__title.length === 0))
                                .map((datum, i) => {
                                    return (
                                        <Grid
                                            container
                                            spacing={2}
                                            key={i}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    fontSize: 14,
                                                    textAlign: "left",
                                                    wordWrap: "break-word",
                                                }}
                                            >
                                                {/* <p>{component === "statements" ? datum.statement : datum.title}</p> */}
                                                <ul>
                                                    <li
                                                        key={i}
                                                        style={{ fontSize: 14 }}
                                                    >
                                                        {component === "statements" ? datum.statement : datum.title}
                                                    </li>
                                                </ul>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                        </div>
                    ) : (
                        <div
                            style={{
                                maxHeight: 200,
                                padding: "20px",
                            }}
                        >
                            <ul>
                                {selectedRows.map((datum, i) => {
                                    return (
                                        <li
                                            key={i}
                                            style={{
                                                fontSize: 13,
                                                paddingLeft: "10px",
                                            }}
                                        >
                                            {component === "statements" ? datum.statement : datum.title}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}
                </DialogContent>
                <DialogActions
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        paddingBottom: "20px",
                    }}
                >
                    <p
                        style={{
                            fontSize: "0.75rem",
                            fontWeight: "600",
                            margin: "0px 100px",
                            textAlign: "center",
                            paddingBottom: "20px",
                        }}
                    >
                        Are you sure to delete the data ?
                    </p>
                    <div>
                        <Button
                            className="custom-btn mx-2"
                            variant="outlined"
                            size="small"
                            onClick={() => setIsDeleteDialogOpen(false)}
                        >
                            Disagree
                        </Button>
                        <Button
                            className="custom-btn mx-2 px-4 liner-light-blue-background"
                            size="small"
                            autoFocus
                            variant="contained"
                            color="error"
                            onClick={handleDelete}
                        >
                            Agree
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    );
}

// Typechecking props
ClaimsDataDeleteComponent.propTypes = {
    title: PropTypes.string,
    component: PropTypes.string,
    selectedRows: PropTypes.array,
    isOpen: PropTypes.bool,
    setIsDeleteDialogOpen: PropTypes.func,
    fetchData: PropTypes.func,
};

export default ClaimsDataDeleteComponent;
